import { hexToRgba, adjustColor } from '../utils/colorUtils';

function buildCss(c, cA, ca60) {
  return `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300&display=swap');

.bv { font-family: 'Cormorant Garamond', Georgia, serif; background: #faf9f7; width: 100%; }

.bv-nav-wrap { position: relative; }
.bv-nav {
  position: absolute; top: 0; left: 0; right: 0; z-index: 10;
  padding: 28px 88px; display: flex; justify-content: space-between; align-items: center;
}
.bv-nav-logo { color: #fff; font-size: 18px; letter-spacing: 0.3em; font-weight: 300; }
.bv-nav-links { display: flex; gap: 48px; }
.bv-nav-link { color: rgba(255,255,255,0.75); font-size: 12px; letter-spacing: 0.2em; cursor: pointer; transition: color 0.2s; }
.bv-nav-link:hover { color: ${c}; }

.bv-hero { position: relative; height: 720px; overflow: hidden; }
.bv-hero-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; filter: brightness(0.42) grayscale(0.15); }
.bv-hero-content {
  position: absolute; inset: 0; display: flex; flex-direction: column;
  justify-content: center; padding: 0 88px;
}
.bv-hero-line { width: 64px; height: 1px; background: ${ca60}; margin-bottom: 44px; }
.bv-hero-h1 {
  color: #fff; font-size: 68px; font-weight: 300; line-height: 1.15;
  letter-spacing: 0.04em; max-width: 760px;
}
.bv-hero-tagline { color: rgba(255,255,255,0.6); font-size: 18px; margin-top: 36px; font-weight: 300; letter-spacing: 0.1em; }
.bv-hero-scroll {
  position: absolute; bottom: 40px; left: 50%; transform: translateX(-50%);
  display: flex; flex-direction: column; align-items: center; gap: 10px;
}
.bv-hero-scroll-text { color: rgba(255,255,255,0.5); font-size: 11px; letter-spacing: 0.25em; }
.bv-hero-scroll-line { width: 1px; height: 48px; background: rgba(255,255,255,0.4); }

.bv-gold-rule { width: 100%; height: 1px; background: ${c}; opacity: 0.4; }

.bv-story { padding: 128px 88px; display: grid; grid-template-columns: 1fr 1fr; gap: 88px; align-items: center; }
.bv-story-label { color: ${c}; font-size: 11px; letter-spacing: 0.35em; margin-bottom: 36px; }
.bv-story-h2 {
  font-size: 42px; font-weight: 300; line-height: 1.5; color: #1a1a1a;
  margin-bottom: 36px; letter-spacing: 0.05em;
}
.bv-story-desc { color: #666; line-height: 2.1; font-size: 16px; letter-spacing: 0.04em; }
.bv-story-cta { margin-top: 52px; display: flex; align-items: center; gap: 20px; cursor: pointer; }
.bv-story-cta-text { font-size: 13px; letter-spacing: 0.25em; color: #1a1a1a; }
.bv-story-cta-line { width: 64px; height: 1px; background: ${c}; transition: width 0.3s; }
.bv-story-cta:hover .bv-story-cta-line { width: 96px; }
.bv-story-img-wrap { position: relative; overflow: hidden; height: 520px; background-color: #f5f5f5; }
.bv-story-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; display: block; filter: grayscale(0.1); transition: transform 0.7s ease; }
.bv-story-img-wrap:hover .bv-story-img { transform: scale(1.04); }

.bv-gallery { padding: 72px 88px 128px; }
.bv-gallery-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; }
.bv-gallery-item { position: relative; overflow: hidden; height: 320px; background-color: #f5f5f5; }
.bv-gallery-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; display: block; filter: grayscale(0.2); transition: transform 0.7s ease, filter 0.4s; }
.bv-gallery-item:hover .bv-gallery-img { transform: scale(1.06); filter: grayscale(0); }

.bv-cta { padding: 128px 88px; text-align: center; }
.bv-cta-label { color: ${c}; font-size: 11px; letter-spacing: 0.35em; margin-bottom: 28px; }
.bv-cta-h2 { font-size: 52px; font-weight: 300; color: #1a1a1a; margin-bottom: 52px; letter-spacing: 0.03em; }
.bv-cta-btn {
  display: inline-block; padding: 16px 64px; border: 1px solid ${c};
  font-size: 13px; letter-spacing: 0.25em; color: ${c};
  cursor: pointer; background: transparent; font-family: inherit;
  transition: background 0.3s, color 0.3s;
}
.bv-cta-btn:hover { background: ${c}; color: #fff; }

.bv-footer {
  padding: 32px 88px; display: flex; justify-content: space-between;
  color: #bbb; font-size: 12px; letter-spacing: 0.12em;
  border-top: 1px solid #e8e8e8;
}

@media (max-width: 768px) {
  .bv-nav { padding: 18px 24px; }
  .bv-nav-links { display: none; }
  .bv-hero { height: 480px; }
  .bv-hero-content { padding: 0 24px; }
  .bv-hero-h1 { font-size: 36px; }
  .bv-story { grid-template-columns: 1fr; padding: 72px 24px; gap: 48px; }
  .bv-story-img-wrap { height: 280px; }
  .bv-gallery { padding: 48px 24px 72px; }
  .bv-gallery-grid { grid-template-columns: 1fr; gap: 12px; }
  .bv-gallery-item { height: 220px; }
  .bv-cta { padding: 72px 24px; }
  .bv-cta-h2 { font-size: 36px; }
  .bv-footer { padding: 24px; flex-direction: column; gap: 8px; }
}
`;
}

export default function BrandVisual({ data }) {
  const c   = data.color || '#c9a96e';
  const cA  = adjustColor(c, 15);
  const ca60 = hexToRgba(c, 0.6);

  return (
    <>
      <style>{buildCss(c, cA, ca60)}</style>
      <div className="bv">
        <div className="bv-nav-wrap">
          <nav className="bv-nav">
            <span className="bv-nav-logo">{data.siteName.toUpperCase()}</span>
            <div className="bv-nav-links">
              {['ABOUT', 'WORK', 'CONTACT'].map(item => (
                <span key={item} className="bv-nav-link">{item}</span>
              ))}
            </div>
          </nav>
          <div className="bv-hero">
            <img src={data.heroImage} alt="" className="bv-hero-img" />
            <div className="bv-hero-content">
              <div className="bv-hero-line" />
              <h1 className="bv-hero-h1">{data.heroHeading}</h1>
              <p className="bv-hero-tagline">{data.tagline}</p>
            </div>
            <div className="bv-hero-scroll">
              <span className="bv-hero-scroll-text">SCROLL</span>
              <div className="bv-hero-scroll-line" />
            </div>
          </div>
        </div>

        <div className="bv-gold-rule" />

        <div className="bv-story">
          <div>
            <p className="bv-story-label">ABOUT US</p>
            <h2 className="bv-story-h2">私たちが<br />目指すもの</h2>
            <p className="bv-story-desc">{data.description}</p>
            <div className="bv-story-cta">
              <span className="bv-story-cta-text">{data.cta.toUpperCase()}</span>
              <div className="bv-story-cta-line" />
            </div>
          </div>
          <div className="bv-story-img-wrap">
            <img src={data.images[0]} alt="" className="bv-story-img" />
          </div>
        </div>

        <div className="bv-gold-rule" />

        <div className="bv-gallery">
          <div className="bv-gallery-grid">
            {data.images.map((img, i) => (
              <div key={i} className="bv-gallery-item">
                <img src={img} alt="" className="bv-gallery-img" />
              </div>
            ))}
          </div>
        </div>

        <div className="bv-gold-rule" />

        <div className="bv-cta">
          <p className="bv-cta-label">GET IN TOUCH</p>
          <h2 className="bv-cta-h2">Let's Work Together</h2>
          <button className="bv-cta-btn">{data.cta.toUpperCase()}</button>
        </div>

        <footer className="bv-footer">
          <span>{data.siteName}</span>
          <span>© 2025</span>
        </footer>
      </div>
    </>
  );
}
